import { gql } from '@apollo/client';

import { AppBaseFields } from './apps.fragment';

export * from './apps.query.generated';

export const APPS = gql`
  ${AppBaseFields}
  query apps(
    $productTypes: [AppProductTypeEnum!]
    $certificationTypes: [AppCertificationTypeEnum!]
    $unclaimed: Boolean
    $unreadTasksExist: Boolean
    $needsFinishing: Boolean
    $productsExist: Boolean
    $owned: Boolean
    $query: String
    $page: Int
    $perPage: Int
  ) {
    apps(
      productTypes: $productTypes
      certificationTypes: $certificationTypes
      unclaimed: $unclaimed
      unreadTasksExist: $unreadTasksExist
      needsFinishing: $needsFinishing
      productsExist: $productsExist
      owned: $owned
      query: $query
      page: $page
      perPage: $perPage
    ) {
      nodesCount
      pagesCount
      nodes {
        ...AppBaseFields
        kind
      }
      hasNextPage
      hasPreviousPage
    }
  }
`;
